// extracted by mini-css-extract-plugin
export default {"node":"mMHzuQSP1bQ4aUKAFQ3m"};